// Items.js
import React from "react";
import { useMenuContext } from "../store/order_context";

const Items = () => {
  const {
    filteredItems,
    userChoices,
    setUserChoices,
    mainCategoryName
  } = useMenuContext();

  const increment = (item) => {
    // Update user choices
    const updatedUserChoices = [...userChoices];
    const itemIndex = userChoices.findIndex(orderItem => orderItem.itemID === item.itemID);
    
    if (itemIndex >= 0) {
      updatedUserChoices[itemIndex].amount += 1;
    } else {
      const newItem = { ...item, mainCategoryName, amount: 1 };
      updatedUserChoices.push(newItem);
    }

    setUserChoices(updatedUserChoices);
  };

  const decrement = (item) => {
    // Update user choices
    const updatedUserChoices = [...userChoices];
    const itemIndex = updatedUserChoices.findIndex(orderItem => orderItem.itemID === item.itemID);
    
    if (itemIndex >= 0) {
      if (updatedUserChoices[itemIndex].amount > 1) {
        updatedUserChoices[itemIndex].amount -= 1;
      } else {
        updatedUserChoices.splice(itemIndex, 1);
      }
    }

    setUserChoices(updatedUserChoices);
  };

  return (
    <div>
      <div className="tabs">
        <div className="tab_body DataPanel">
          <div className="food_menu">
            <ul>
              {filteredItems && filteredItems.map((item) => (
                <li key={item.itemID}>
                  <span className="name">{item.itemName}</span>
                  <div className="counter">
                    <span className="input-number-increment adjust" onClick={() => increment(item)}>+</span>
                    <input className="input-number" value={userChoices && userChoices.find(userItem => userItem.itemID ===item.itemID)?.amount || 0} type="text" readOnly />
                    <span className="input-number-decrement adjust" onClick={() => decrement(item)}>–</span>
                  </div>
                  <span className="price">{item.itemPrice}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Items;
